export const DESIGN_DNA_REFERENCE_TABLE = [
  { Category: 'Dashboard Layouts', Share: '42%', Examples: 'Analytics, KPI grids, admin panels' },
  { Category: 'AI Workspace', Share: '28%', Examples: 'Chat surfaces, command palette, context panels' },
  { Category: 'Analytics', Share: '18%', Examples: 'Data tables, charts, SEO dashboards' },
  { Category: 'Landing Pages', Share: '7%', Examples: 'Hero sections, marketing shells' },
  { Category: 'Branding', Share: '5%', Examples: 'Typography, color systems, iconography' },
]

export const DESIGN_DNA_SIGNALS_TABLE = [
  { Signal: 'Dark Surfaces', Strength: 'Strong', Frequency: '82%' },
  { Signal: 'Rounded Cards (12–20px)', Strength: 'Strong', Frequency: '80%' },
  { Signal: 'Subtle Borders', Strength: 'Strong', Frequency: '76%' },
  { Signal: 'Sidebar Layouts', Strength: 'Strong', Frequency: '71%' },
  { Signal: 'Blue Accents (#4F7DFF)', Strength: 'Strong', Frequency: '68%' },
  { Signal: 'Glass Effects', Strength: 'Weak', Frequency: '10%' },
  { Signal: 'Heavy Gradients', Strength: 'Rejected', Frequency: '8%' },
]

export const DESIGN_DNA_PHILOSOPHY_YAML = `Primary Philosophy:
AI Native Productivity

Secondary Philosophy:
Premium SaaS

Tertior Philosophy:
Editorial Minimalism`

export const DESIGN_DNA_BRAND_YAML = `Brand Personality:
Intelligent
Premium
Reliable
Sophisticated
Focused
Trustworthy`

export const DESIGN_DNA_TOKENS_YAML = `Colors:
  Background: "#0B0D0F"
  Surface: "#111418"
  Card: "#171B20"
  Accent: "#4F7DFF"

Radius:
  Button: 12px
  Card: 20px
  Dialog: 24px

Spacing: 4, 8, 12, 16, 24, 32, 48, 64

Typography:
  Hero: 56
  H1: 48
  H2: 36
  Body: 14
  Meta: 12`
